module.exports = __webpack_public_path__ + "img/center-role.efa05877.png";